import { useQuery } from '@tanstack/react-query';
import { GetProcessStartSettings } from '../helper/apiHelper';
import { QUERY_KEYS } from '../Constants/queryKeys';
import type { ProcessStartSettings } from '../Types/interfaces';

const ALL_ENABLED: ProcessStartSettings = {
  companyRegistrationEnabled: true,
  internshipApplicationEnabled: true,
  internshipOfferCreationEnabled: true,
};

/**
 * Which processes may currently be started. While loading (or if the request fails) everything is
 * treated as enabled; the API enforces the real restriction either way.
 */
export const useProcessStartSettings = (): ProcessStartSettings => {
  const { data } = useQuery({
    queryKey: QUERY_KEYS.PROCESS_START_SETTINGS,
    queryFn: GetProcessStartSettings,
    staleTime: 60 * 1000,
  });

  return data ?? ALL_ENABLED;
};
